//Header Script Start Here
if ($(window).width() >= 768) {
const header = document.getElementById('header');
const initialOffsetTop = header.offsetTop;
window.onscroll = function() {
  if (window.pageYOffset > initialOffsetTop) {
    header.classList.add('fixed-header');
  } else {
    header.classList.remove('fixed-header');
  }
};
}

//Header Fixed
$(document).ready(function () {
  if ($(window).width() <= 767) {
    const header = document.querySelector(".header");
    let lastScroll = window.scrollY;
    
    // Initial state on page load
    if (lastScroll > 0) {
      header.classList.remove("transparent");
      header.classList.add("showHeader");
    } else {
      header.classList.add("transparent");
      header.classList.remove("showHeader", "hideHeader");
    }
    
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
    
      if (currentScroll === 0) {
        header.classList.add("transparent");
        header.classList.remove("hideHeader", "showHeader");
      } else {
        header.classList.remove("transparent");
    
        if (currentScroll > lastScroll) {
          header.classList.add("hideHeader");
          header.classList.remove("showHeader");
        } else {
          header.classList.add("showHeader");
          header.classList.remove("hideHeader");
        }
      }
    
      lastScroll = currentScroll;
    });
  }
});
//Header Script End Here

//Header Announcements
document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector("#shopify-section-announcement-bar");
  const content = document.querySelector(".header_announcements");
  const close = document.querySelector(".close_announcement");

  if (bar && content) bar.classList.add("announcement-visible");
  close?.addEventListener("click", () => {
    bar.classList.remove("announcement-visible");
    content.style.display = "none";
  });
});

// function adjustHeaderTop() {
//   const announcement = document.querySelector('.header_announcements');
//   const header = document.querySelector('.header');

//   if (announcement && header) {
//     const isVisible =
//       announcement.offsetHeight > 0 &&
//       getComputedStyle(announcement).display !== 'none' &&
//       getComputedStyle(announcement).visibility !== 'hidden';

//     header.style.top = isVisible ? `${announcement.offsetHeight}px` : '1rem';
//   }
// }
//Header Announcements Ends

// ONLY run this when close button is clicked
document.querySelector('.close_announcement')?.addEventListener('click', function () {
  document.querySelector('.header_announcements').style.display = 'none';
  adjustHeaderTop();
});


// Function to show the modal
function showmodal(target) {
  const modal = document.querySelector(target);
  if (modal) {
    modal.classList.add('show');
    //document.body.classList.add('scroll');
  } else {
    console.error("Modal target not found:", target);
  }
}

function modalClose() { 
    $("#searchBar").removeClass('show');
    // document.body.classList.remove('scroll');
}

//Cart Page Script Start Here
$(document).ready(function() {
  // Increase quantity
  $(document).on('click', '.qty-inc', function() {
    var variantId = $(this).data('variant-id');
    var currentQuantity = $('#input-' + variantId).val();
    var newQuantity = parseInt(currentQuantity) + 1;
    updateCartQuantity(variantId, newQuantity);
  });

  // Decrease quantity
  $(document).on('click', '.qty-dec', function() {
    var variantId = $(this).data('variant-id');
    var currentQuantity = $('#input-' + variantId).val();
    var newQuantity = Math.max(0, parseInt(currentQuantity) - 1);     
    updateCartQuantity(variantId, newQuantity);
  });

  $(document).on('input', '.cart-quantity-input', function() {
    var variantId = $(this).data('variant-id');
    var currentQuantity = $('#input-' + variantId).val();
    var newQuantity = parseInt(currentQuantity);
    if (newQuantity > 0) {
      updateCartQuantity(variantId, newQuantity);
    }
  });

  // Handle input change for quantity
  function cartOnchange(inputElement) {
    var variantId = $(inputElement).data('variant-id');
    var newQuantity = $(inputElement).val();
    updateCartQuantity(variantId, newQuantity);
  }

  // Update the cart quantity via AJAX
  function updateCartQuantity(variantId, quantity) {
    $('#allcartdata').addClass('added_loading');
    $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      data: {
        updates: {
          [variantId]: quantity
        }
      },
      success: function(response) {
        let cartCount = $('#cartCount');
        let updatedCount = response.item_count;
        if (updatedCount === 0) {
          cartCount.hide();
        } else {
          cartCount.html(updatedCount).show();
        }
        refreshCartSections();
      },
      error: function(xhr, status, error) {
        console.error("Error updating cart:", error);
        $('#allcartdata').addClass('added_loading');
      }
    });
  }

  // Remove item from the cart
  $(document).on('click', '.item_remove', function() {
    $('#allcartdata').addClass('added_loading');
    var variantId = $(this).data('variant-id');
    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 0
      },
      success: function(response) {
        let cartCount = $('#cartCount');
        let updatedCount = response.item_count;
        if (updatedCount === 0) {
          cartCount.hide();
        } else {
          cartCount.html(updatedCount).show();
        }
        refreshCartSections();
      },
      error: function(xhr, status, error) {
        console.error("Error removing item:", error);
        $('#allcartdata').removeClass('added_loading');
      }
    });
  });

  // Function to refresh cart sections
  function refreshCartSections() {
    $.ajax({
      url: '/?section_id=main-cart',
      method: 'GET',
      dataType: 'html',
      success: function(response) {
        var updatedCart = $(response).find('#allcartdata').html();
        setTimeout(function name(params) {
        $('#allcartdata').html(updatedCart);
        $('#allcartdata').removeClass('added_loading');  
        }, 100);
      },
      error: function(xhr, status, error) {
        console.error("Error rendering cart section:", error);
      }
    });
  }
});
//Cart Page Script End Here

//Add to cart Button Script Start Here
$(document).ready(function() {
  $(document).on("click", ".add-to-cart-ajax", function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var variantId = form.find('input[name="id"]').val();
    var properties = {};
    form.find('input[name^="properties["]').each(function() {
      var key = $(this).attr('name').match(/properties\[(.+)\]/)[1];
      properties[key] = $(this).val();
    });
    var $addToCartButton = $(this);
    var originalBtnText = $addToCartButton.html();
    $addToCartButton.html('<span>Adding...</span>').prop('disabled', true);

    var itemData = { id: variantId, quantity: 1 };
    if (Object.keys(properties).length > 0) {
      itemData.properties = properties;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items: [itemData] },
      success: function (response) {
        $addToCartButton.html(originalBtnText).prop('disabled', false);
        getCart(function() {
          openSidebarCart();
        });
      },
      error: function (error) {
        console.error('Error add to cart:', error);
        $addToCartButton.html(originalBtnText).prop('disabled', false);
        alert('Error adding product to cart. Please try again.');
      }        
    });
  });

  function openSidebarCart() {
    $('body').addClass('scroll show_cart');
  }

  function getCart(callback) {
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function(cart) {
        renderCart(cart);
        updateCartSummary(cart);
        if (typeof callback === 'function') {
          callback();
        }
      },
      error: function(xhr, status, error) {
        console.error('Error fetching cart:', error);
      }
    });
  }

  function updateCartSummary(cart) {
    $('#cartCount').text(cart.item_count);
    $('#totalPrice').text(`$${(cart.total_price / 100).toFixed(2)}`);
    if (cart.item_count == 0) {
      $('#cartBtn').addClass('disabled');
      $('#checkoutBtn').addClass('disabled');
      $('#cartCount').hide();
    } else {
      $('#cartBtn').removeClass('disabled');
      $('#checkoutBtn').removeClass('disabled');
      $('#cartCount').show();
    }
  }

  function renderCart(cart) {
    const cartContainer = $('#sidebarCart');
    if (cart.item_count === 0) {
      cartContainer.html('<p class="my-2 text-center">YOUR SHOPPING CART IS EMPTY</p>');
      return;
    }

    let cartItemsHTML = '';
    $.each(cart.items, function(index, item) {
      cartItemsHTML += `
        <div class="header_cart_sidebar_item" data-variant-id="${item.variant_id}">
          <div class="header_cart_item_img">
            <a href="${item.url}"><img src="${item.image}" alt="${item.title}" class="img-fluid w-100"></a>
          </div>
          <div class="header_cart_item_info">
            <div class="header_cart_item_header">
              <div class="header_cart_item_body">
                <a href="${item.url}"><h5 class="mb-1">${item.title}</h5></a>
                <p class="mb-0">${item.product_type}</p>
                ${item.properties && Object.keys(item.properties).length > 0 ? Object.entries(item.properties).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => `<p class="mb-0"><small>${k}: ${v}</small></p>`).join('') : ''}
              </div>
              <div class="header_cart_item_price">
                <p class="mb-0">$${(item.original_line_price / 100).toFixed(2)}</p>
              </div>
            </div>
            <div class="header_cart_item_footer">
              <button type="button" class="dec-item" data-variant-id="${item.variant_id}" data-type="dec">
                <img src="https://cdn.shopify.com/s/files/1/0741/4739/7874/files/minus.svg?v=1740425883" alt="-" width="16">
              </button>
              <input type="number" value="${item.quantity}" data-variant-id="${item.variant_id}" class="cart-quantity-input" min="">
              <button type="button" class="inc-item" data-variant-id="${item.variant_id}" data-type="inc">
                <img src="https://cdn.shopify.com/s/files/1/0741/4739/7874/files/plus.svg?v=1740425883" alt="+" width="16">
              </button>
            </div>
          </div>
        </div>
      `;
    });

    cartContainer.html(cartItemsHTML);
  }

  function updateCart(variantId, quantity) {
    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: quantity
      },
      success: function(cart) {
        renderCart(cart);
        updateCartSummary(cart);
      },
      error: function(xhr, status, error) {
        console.error('Error updating cart:', error);
      }
    });
  }

  $(document).on('click', '.inc-item', function() {
    const variantId = $(this).data('variant-id');
    const quantityInput = $(`.cart-quantity-input[data-variant-id="${variantId}"]`);
    let currentQuantity = parseInt(quantityInput.val());
    quantityInput.val(currentQuantity + 1);
    updateCart(variantId, currentQuantity + 1);
  });

  $(document).on('click', '.dec-item', function() {
    const variantId = $(this).data('variant-id');
    const quantityInput = $(`.cart-quantity-input[data-variant-id="${variantId}"]`);
    let currentQuantity = parseInt(quantityInput.val());
    if (currentQuantity > 0) {
      quantityInput.val(currentQuantity - 1);
      updateCart(variantId, currentQuantity - 1);
    }
  });

  $(document).on('input', '.cart-quantity-input', function() {
    const variantId = $(this).data('variant-id');
    let quantity = parseInt($(this).val());
    if (quantity > 0) {
      updateCart(variantId, quantity);
    }
  });
  getCart();
});

//Add to cart Button Script End Here


